import React, { createRef, useEffect } from 'react'
import PropTypes from 'prop-types'

const MinusRoundedRectangleIcon = ({ fill = '' }) => {
    const pathRef = createRef()
    useEffect(() => {
        if (pathRef?.current) {
            pathRef.current.style.fill = fill?.length === 0 ? '#FF4365' : fill
        }
    }, [fill])
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
            <path ref={pathRef} d="M20.2375 2.5H9.7625C5.2125 2.5 2.5 5.2125 2.5 9.7625V20.225C2.5 24.7875 5.2125 27.5 9.7625 27.5H20.225C24.775 27.5 27.4875 24.7875 27.4875 20.2375V9.7625C27.5 5.2125 24.7875 2.5 20.2375 2.5ZM20 15.9375H10C9.4875 15.9375 9.0625 15.5125 9.0625 15C9.0625 14.4875 9.4875 14.0625 10 14.0625H20C20.5125 14.0625 20.9375 14.4875 20.9375 15C20.9375 15.5125 20.5125 15.9375 20 15.9375Z" />
        </svg>
    )
}

MinusRoundedRectangleIcon.propTypes = {
    fill: PropTypes.string
}

export default MinusRoundedRectangleIcon
